/* This is the shared components for page 6 of secondary school */
<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តម្លៃសិក្សាតាមកម្រិតថ្នាក់និង<br/>ថវិកាដំណើរការសាលារៀន
      </v-tab>                
      <v-tab-item>
        <div class="row">
          <prefee :data="feepre" :title="title[1]" :lst_acc="lst_acc" />
          <privfee :data="feepri" :title="title[2]" :colTitle="priLevel" :lst_acc="lst_acc"/>
          <privfee :data="feesec" :title="title[3]" :colTitle="secLevel" :lst_acc="lst_acc"/>
          <privbud :data="schbud" :title="title[4]"/>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>


<script>
import preSchoolFee from "@/components/privateascf/pre/preSchoolfee.vue";
import privSchoolFee from "@/components/privateascf/sharedCom/privSchoolfee.vue";
import privSchoolBudget from "@/components/privateascf/sharedCom/privSchoolBudget.vue";
import { priLevel } from "@/utils/priascf/priVariables.js";
import { secLevel } from "@/utils/priascf/secVariables.js";

export default {
  props: ["title", "feepre", "feepri", "feesec", "schbud", "lst_acc"],
  components: {
    prefee: preSchoolFee,
    privfee: privSchoolFee,
    privbud: privSchoolBudget
  },
  data() {
    return {
      active_tab: 0,
      privfee: privSchoolFee,
      privSchoolBudget: privSchoolBudget,
      priLevel: priLevel,
      secLevel: secLevel,
    };
  },
};
</script>
<style scoped>
.row {
  display: flex;
}
</style>